module.exports = __webpack_public_path__ + "static/media/pinterest.46a0a8f2.svg";